import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProductsResponse } from 'core/types/product';
import { makePrivateRequest, makeRequest } from 'core/utils/request';
import { toast } from 'react-toastify';
import Pagination from 'core/components/Pagination';
import CardLoader from '../Loaders/ProductCardLoader';
import Card from '../Card';
import ProductFilters from 'core/components/ProductFilters';
import { Category } from 'core/types/product';
import './styles.scss';

const List = () => {    
    const [productsResponse, setProductsResponse] = useState<ProductsResponse | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activePage, setActivePage] = useState(0);
    const [name, setName] = useState('');
    const [category, setCategory] = useState<Category>();
    const navigate = useNavigate();
    

    const getProducts = useCallback(() => {
        const params = {
            page: activePage,
            linesPerPage: 4,
            name,
            categoryId: category?.id
        }
        setIsLoading(true);
        makeRequest({ url: '/products', params})
            .then(response => {
                if (response.data) {
                    setProductsResponse(response.data);
                } else {
                    setProductsResponse(null);
                }
            })
            .catch(() => {
                setProductsResponse(null);
            })
            .finally(() => {
                setIsLoading(false);                
            })
    }, [activePage, name, category]);
    
    useEffect(() => {
       getProducts();
    }, [getProducts]);
    

    const handleChangeName = (name: string) => {
        setActivePage(0);
        setName(name);
    }

    const handleChangeCategory = (category: Category) => {
        setActivePage(0);
        setCategory(category);
    }

    const clearFilters = () => {
        setActivePage(0);
        setName('');
        setCategory(undefined);
    }

    const handleCreate = () => {
        navigate('create');
    }

    const onRemove = (productId: number) => {
        const confirm = window.confirm( "Deseja realmente excluir este produto");

        if(confirm){
            makePrivateRequest({ url: `/products/${productId}`, method: 'DELETE' })
                .then(() => {
                    toast.info("Produto removido com sucesso!");
                    getProducts();
                })
                .catch(() => {
                    toast.error('Erro ao remover produto!');
            })
        }
        
    }

    return (
        <div className="admin-products-list">
            <div className="d-flex justify-content-between">
                <button className="btn btn-primary btn-lg" onClick={handleCreate}>
                    ADICIONAR
                </button>
                <ProductFilters
                    name={name}
                    category={category}
                    handleChangeCategory={handleChangeCategory}
                    handleChangeName={handleChangeName}
                    clearFilters={clearFilters}
                />
            </div>

            <div className="admin-list-container">
                {isLoading ? <CardLoader /> : (
                    productsResponse?.content?.map(product => (
                        <Card key={product.id} product={product}  onRemove={onRemove} />
                    ))
                )}
                
                {productsResponse && productsResponse.totalPages > 0 && (
                    <Pagination 
                        totalPages={productsResponse.totalPages}
                        activePage={activePage}
                        onChange={page => setActivePage(page)}
                    />
                )}
            </div>
        </div>
    )
}

export  default List;